module.exports = ".contenedor {\r\n    padding: 10%;\r\n}"